<template>
  <div class="redirect">
    <div class="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading">
      <div class="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>
  import constants from "../../constants";
  import authenService from "../../services/authenService";
  import VueCookies from 'vue-cookies';

  export default {
    name: "Logout",

    created() {
      this.redirectToSSOPage();
    },

    methods: {
      redirectToSSOPage() {
        authenService.removeToken().then(() => {
          let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
          let redirect_uri = encodeURIComponent(constants.SSO_LOGOUT_CALLBACK);
          VueCookies.remove("IdHash");

          window.location.href = `${
            constants.SSO_URL_LOGOUT
          }?client_id=${client_id}&redirect_uri=${redirect_uri}`;
        });
      }
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/Logout.vue